/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetRasterForTunnelSection$Params {
  sectionId: string;
}

export function getRasterForTunnelSection(http: HttpClient, rootUrl: string, params: GetRasterForTunnelSection$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, getRasterForTunnelSection.PATH, 'get');
  if (params) {
    rb.path('sectionId', params.sectionId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

getRasterForTunnelSection.PATH = '/v1/raster/rasterexport/{sectionId}';
